module.exports = __webpack_public_path__ + "static/media/followIcon.bd38f9b3.svg";